import React from 'react'
import { useEffect, useContext } from 'react'
import TVChartContainer from './TVChartContainer'
import SocketContext from 'context/context'

export default function TradingViewChart(props) {
  const { selectedMarket } = props
  const { state, setState } = useContext(SocketContext)

  useEffect(() => {
    setState({
      ...state,
      klines: {
        symbol: selectedMarket,
        data: [],
      },
    })
  }, [selectedMarket])
  return (
    <TVChartContainer
      symbol={selectedMarket || 'ETH-USDT'}
    />
  )
}
